import * as React from 'react';
import * as get from "./style.module.scss";

export const Get = () => {
  return (
    <section className={get.get}>
      <div className="container">
        <div className={get.wrap}>
          <div className={`${get.block} ${get.blockChild}`}>
            <h3 className={get.block__title}>Что получает ребёнок:</h3>
            <ul>
              <li className={get.block__text}>обратную связь и помощь в освоении материала;</li>
              <li className={get.block__text}>дополнительные задания на&nbsp;закрепление и&nbsp;проверку полученных
                навыков;
              </li>
              <div className={get.block__text}>общение с&nbsp;другими учениками.</div>
            </ul>
          </div>
          <div className={`${get.block} ${get.blockParent}`}>
            <h3 className={get.block__title}>Что получает родитель:</h3>
            <ul>
              <li className={get.block__text}>экспертную помощь в&nbsp;обучении ребёнка;</li>
              <li className={get.block__text}>информирование о&nbsp;том, как ребёнок проходит курс.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
